import { useTranslation } from 'react-i18next'
import { RegisterForm } from '@/components/features/auth'

export function RegisterPage() {
  const { t } = useTranslation('auth')

  return (
    <div className="w-full max-w-lg">
      <div className="mb-8 text-center">
        <h1 className="text-2xl font-bold">{t('createAccount')}</h1>
        <p className="text-muted-foreground">{t('registerSubtitle')}</p>
      </div>
      <RegisterForm />
    </div>
  )
}
